import React, { Component } from 'react';
import firebase from 'firebase';
import Modal from 'react-modal';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Alert from 'react-s-alert';
import Select from 'react-select';
import {sendLog} from '../../util'

const database = firebase.database();

const customStyles = {
	content : {
	  top                   : '50%',
	  left                  : '50%',
	  right                 : 'auto',
	  bottom                : 'auto',
	  transform             : 'translate(-50%, -50%)',
	  width                 : '450px',
	  height: '550px',	 
	  
	}
  };

class Modal_Vehiculos extends Component {
	
	constructor(){
		
		super();
		this.state={
		    socios:[],
			isActiveSocios:false,
			isActiveBases:false,
			bases:[],
			conductores:[],
			tipo_vehiculo:'',
			marca:'',
			modelo:'',
			anio:'',
			placa:'',
			capacidad:'',
			foto:'',
			disponibilidad:'',
			codigo_socio:'',
			estado:'',
			urlFoto:'',
			uploadValue:0,
			files:null,
			base:'',
			nodoBase:'',
			tipos:[],
			empresas:[],
			empresaL:[],
			checkAdmin:false
			
		};
		
		this.handleUpload=this.handleUpload.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);
		this.handleClick=this.handleClick.bind(this);
		this.handleKeyPressLetras=this.handleKeyPressLetras.bind(this);
		this.handleKeyPressNumeros=this.handleKeyPressNumeros.bind(this);
		this.handleClickBases=this.handleClickBases.bind(this);
		this.makeOptions=this.makeOptions.bind(this);
		
		
		this.basesRef=database.ref().child('Bases');
		this.empleadosRef=database.ref().child('Vehiculos');
		this.sociosRef=database.ref().child('Socios');
		this.tiposVehiculos=database.ref().child('Tipos_Vehiculos');
		
		
	}
	
	componentWillMount(){
		
		Modal.setAppElement('body');
	}
	
	componentDidMount(){
		
		this.tiposVehiculos.on('value',this.gotDataTipos,this.errDataTipos);
		this.sociosRef.on('value',this.gotDataSocios,this.errDataSocios);
		this.basesRef.on('value',this.gotDataBases,this.errDataBases);
		this.getEmpresas();
		this.checkSAdmin();
		
	}

	checkSAdmin = () => {
		let id = firebase.auth().currentUser.uid;
		firebase.database().ref("superAdmin").once("value").then(rows => {
			rows.forEach( element => {
				let data = element.val();
				data.key = element.key;
				if (data.key === id) {
					this.setState({checkAdmin:true})
				}
			})
		})
	}
	
	getEmpresas = () => {

		let empresas = []
		firebase.database().ref('Empresa').once('value').then(snap => {
			snap.forEach( element => {
				let empresa = element.val();
				empresa.key = element.key;
				// console.log(empresa.key);
				empresas.push({value:empresa.key, label:empresa.codigo_empresa});
				// console.log(empresas);
			})
			this.setState({empresas})
		});

	}

		gotDataSocios=(data) =>{
		let newsocios = []
		const sociosdata = data.val();
		if(data.val()!==null){
		const keys = Object.keys(sociosdata);

		for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
	

			if(sociosdata[k].Estado!=='Inactivo'){
				
				newsocios.push({
				  key:k,
				  nombre:sociosdata[k].Nombre,
				  apellido:sociosdata[k].Apellido,
				  estado:sociosdata[k].Estado

				});			


			
			}

	
			
		 }
		this.setState({socios: newsocios});
		}
	}
	errDataSocios = (err)=>{
		
		console.log(err);
		
	}

	
		gotDataBases = (data) => {
		
		
		  let newBase = [];
		  const basedata = data.val();
		  const keys = Object.keys(basedata);

		  for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
			
			newBase.push({
			  key:k,
			  nombre:basedata[k].Nombre,
			  descripcion:basedata[k].Descripcion,
			  foto:basedata[k].foto,
			  latitud:basedata[k].latitud,
			  longitud:basedata[k].longitud,
			  direccion:basedata[k].direccion
			});
		  }
		  this.setState({bases: newBase});
		}
		errDataBases = (err) => {
			console.log(err);
		}

	toggleModal=()=>{
		
		this.setState({
			isActive:!this.state.isActive,
			foto:null,
			uploadValue:0
		})
	}	
	
	
	gotDataTipos=(data)=>{
		
		let newTipos=[]
		
		
		if(data.val()!==null){
			
			 const vehiculodata = data.val();
			let tipos=data.val();
			let keys=Object.keys(tipos);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				
				
				if(tipos[k].estado==='Activo'){
						
					newTipos.push({
						tipo:tipos[k].tipo,
						estado:tipos[k].estado
					})
					
					
				}
				
			}
			this.setState({tipos:newTipos})
			
			
			
		}
		
		
	}
	errData=(err)=>{
		
		console.log(err);
		
	}
	
	
	toggleModalSocios=()=>{
		this.setState({
			
			isActiveSocios:!this.state.isActiveSocios
			
		})
	}
	
	toggleModalBases=()=>{
		
		this.setState({
			
			isActiveBases:!this.state.isActiveBases
			
		})
		
		
	}
	
	handleSubmit(event){
		
		let {empresaL} = this.state;
		
		let archivo=this.state.files;
		const storageRef = firebase.storage().ref(`Vehiculos/${archivo.name}`);
		
		const task= storageRef.put(archivo);
		
		task.on('state_changed', snapshot =>{
		
		
		this.setState({
		  uploadValue :50,
		})

		}, error =>{ console.log(error.message);
		},
		()=>{
			

			let uidG = firebase.auth().currentUser.uid;
			const idKey = this.empleadosRef.push({
			
					tipo_vehiculo:this.tipoVehiculo.value,
					marca:this.marcaVehiculo.value,
					modelo:this.modeloVehiculo.value,
					anio:this.anioVehiculo.value,
					placa:this.placaVehiculo.value,
					capacidad:this.capacidadVehiculo.value,
					foto:task.snapshot.downloadURL,
					codigo_socio:this.socioKey.value,
					estado:this.estadoVehiculo.value,
					base:this.state.nodoBase, 
					movil:this.movilVehiculo.value,
					empresas:empresaL,
					createAt: firebase.database.ServerValue.TIMESTAMP,
					createdBy: uidG
			}).key
	
			
			this.setState({
				uploadValue:100,
				urlFoto:task.snapshot.downloadURL
			});
			
			this.toggleModal();
			sendLog({ tipo: 'vehiculo_nuevo', informacion_extra: {vehiculo: idKey}})
			Alert.success('Datos guardados correctamente', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000			
			});
			 

		});
	
		
	
		event.preventDefault();
	
	}
	
	handleUpload(e,filee){
		
		var file= e.target.files[0],
		pattern= /image-*/,
		reader=new FileReader();
		
		if(file===undefined){
			
			this.setState({ 
				 foto:null,
				 files:null
			}); 
			
		}
		else{
			
			if(!file.type.match(pattern)){
			
					Alert.error('Por favor ingresa una imagen con formato valido', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
					});
					return;
				}
		


				reader.onload = (e) => {
					this.setState({ 
						foto:reader.result,
						files:file
					}); 
				}		
			
				reader.readAsDataURL(file);	
		}	
	}
	
	handleClick=(rowKey)=>{
		
		this.setState({
			isActiveSocios:!this.state.isActiveSocios
		})
		
		
		this.socioKey.value=rowKey.key;
		this.socioVehiculo.value=rowKey.nombre+' '+rowKey.apellido; 
		
	}
	
	handleClickBases=(rowKey)=>{
		
		
		this.baseKey.value=rowKey.nombre;
		this.state.nodoBase=rowKey.key;
		
		this.toggleModalBases();
		
	}
	
	
	btnSoiciosFormatter(cell,row) {

		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Seleccionar</button>;
	}
	
	btnBasesFormatter(cell,row){
		
		
		return <button className="btn btn-success btn-sm" onClick={() => {this.handleClickBases(row)}} >Seleccionar</button>;
	}
	
	
	handleKeyPressLetras(e){
		
		let tecla=e.which;
		
		let patron =/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs && tecla!=32 && tecla!=91 ){			
			e.preventDefault();		
		}	
	}
	
	handleKeyPressNumeros(e){
	
		let tecla=e.which;		
		let patron =/^[0-9]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs){
			e.preventDefault();		
		}
	
	}

	changeEmpresa = (event) => {
		let empresaL = []
		event.forEach( element => {
			
			empresaL.push(element.value);
		})
		this.setState({empresaL})

	}
	
	
	makeOptions(x){
		
		
		return <option>{x.tipo}</option>
		
	}
	
	
  render() {
	
	let {empresas} = this.state;
	let {checkAdmin} = this.state;

    return (
		
		<div className="ingreso_vehiculos">
			
			{checkAdmin &&
				<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
			}
			
			
			<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >				
				<h3>Agregar Vehiculo</h3>
				<hr/>
	
				
				<form method="POST" action="" onSubmit={this.handleSubmit}>
					
					<div className="form-group">
						<label htmlFor="movil">Unidad</label>
						<input type="text" name="movil" className="form-control"
						placeholder="Movil" required autoComplete="off"
						ref={input => {this.movilVehiculo=input;}}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="marca">Marca</label>
						<input type="text" name="marca" className="form-control"
						placeholder="Marca" required autoComplete="off"
						ref={input => {this.marcaVehiculo=input;}}
						onKeyPress={this.handleKeyPressLetras}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="modelo">Modelo</label>
						<input type="text" name="modelo" className="form-control"
						placeholder="Modelo" required autoComplete="off"
						ref={input => {this.modeloVehiculo=input;}}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="anio">Año</label>			
						<input type="text" name="anio" className="form-control"
						placeholder="Año" required autoComplete="off"
						ref={input => {this.anioVehiculo=input;}}
						onKeyPress={this.handleKeyPressNumeros}
						maxLength="4" minLength="4"
						/>
					</div>
				
					<div className="form-group">
						<label htmlFor="placa">Placa</label>
						<input type="text" name="placa" className="form-control"
						placeholder="Placa" required autoComplete="off"
						ref={input => {this.placaVehiculo=input;}}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="capacidad">Capacidad</label>
						<input type="text" name="capacidad" className="form-control"
						placeholder="Capacidad" required autoComplete="off"
						ref={input => {this.capacidadVehiculo=input;}}
						onKeyPress={this.handleKeyPressNumeros}
						maxLength="2"
						/>
					</div>
					<div className="form-group">
						<label htmlFor="tipo_vehiculo">Tipo Vehiculo</label>
						<select name="tipo_vehiculo" className="form-control"
						ref={input => {this.tipoVehiculo=input;}}
						>
						{this.state.tipos.map(this.makeOptions)}
						</select>
					</div>
					
					
				
					<div className="form-group">
						<label htmlFor="socio">Socios</label>
						<input type="text" className="form-control"
						ref={input => {this.socioVehiculo=input;}}
						readOnly="readonly" required autoComplete="off"
						onClick={this.toggleModalSocios}
						placeholder="Elige un socio"
						/>
						<input type="hidden" name="keySocio" 
						ref={input =>{this.socioKey=input;}}
						/>
					</div>
					
					<div className="form-group">
						<label htmlFor="base">Base</label>
						<input type="text" className="form-control" 
						ref={input => {this.baseVehiculo=input;}}
						readOnly="readOnly" required autoComplete="off"
						placeholder="Elije una base" 
						onClick={this.toggleModalBases}
						ref={input =>{this.baseKey=input;}}
						
						/>
					</div>
					
					<div className="form-group">
						<label htmlFor="socio">Empresas</label>
						<Select onChange={this.changeEmpresa} options={empresas} isMulti />
					</div>
					
					
					<div className="form-group">
						<label htmlFor="estado">Estado</label>
						<select name="estado" className="form-control"
						ref={input => {this.estadoVehiculo=input;}}
						>
							<option value="Disponible">Disponible</option>
							<option value="Asignado">Asignado</option>
						</select>
					</div>
					
					<div className="form-group">
						<label htmlFor="foto">Fotografia del vehiculo</label>
						<br/>
						<progress value={this.state.uploadValue} max="100"></progress>
						<input type="file" className="form-control"  onChange={this.handleUpload} required/>
					</div>
					<div className="image">
						<img src={this.state.foto} className="foto"  width="250px;" alt="foto vehiculo"/>
					</div>
					<br/>
					<button className="btn btn-primary buttons" type="submit" >Guardar</button>
					<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
						
						
				</form>	
			</Modal>
			
			<Modal isOpen={this.state.isActiveSocios} onRequestClose={this.toggleModalSocios}  style={customStyles}>
						<h4>Selecciona un socio</h4>
						<hr/>
					
					<BootstrapTable data={ this.state.socios}
						 ref='table'
						 pagination={ true }
						 search={ true }
						 hover
						 >
						 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='nombre' dataSort={true}  >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='apellido' dataSort={true}  >Apellido</TableHeaderColumn>
						 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnSoiciosFormatter.bind(this) }>Seleccionar</TableHeaderColumn>
					</BootstrapTable>					
			</Modal>
					
			<Modal isOpen={this.state.isActiveBases} onRequestClose={this.toggleModalBases} style={customStyles}>
						<h4>Selecciona una base</h4>
						<hr/>
						<BootstrapTable data={ this.state.bases}
							 ref='table'
							 pagination={ true }
							 search={ true }
							 hover
							 >
							 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							 <TableHeaderColumn dataField='nombre' dataSort={true}  >Nombre</TableHeaderColumn>						
							 <TableHeaderColumn dataField='direccion' dataSort={true}  >Direccion</TableHeaderColumn>							 
							 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnBasesFormatter.bind(this) }>Seleccionar</TableHeaderColumn>
						</BootstrapTable>
						
						
			</Modal>
			
			
			
		</div>
    );
  }
}

export default Modal_Vehiculos;



// WEBPACK FOOTER //
// ./src/Components/Vehiculos/modal_vehiculos.js